import React        from 'react';
import {
  reduxForm,
  Field,
}                   from 'redux-form';
import SubmitButton from 'components/ui/form/submit_button';
import Title        from 'components/ui/titles';

const ProcessingLimitRequestsForm = ({ submitting, handleSubmit }) => (
  <React.Fragment>
    <Title
      size="h3"
      className="uk-text-center"
    >
      { t('gdpr.options.data_processing_limit_requests') }
    </Title>
    <p>{ t('gdpr.data_processing_limit_requests.show.info_1') }</p>
    <p>{ t('gdpr.data_processing_limit_requests.show.info_2') }</p>
    <form onSubmit={ handleSubmit } className="mt-20">
      <Field
        type="text"
        name="message"
        className="uk-textarea"
        component="textarea"
        required="required"
      />
      <SubmitButton
        className="mt-20"
        loading={ submitting }
      />
    </form>
  </React.Fragment>
);

export default reduxForm({
  form: 'processing_limit_requests',
})(ProcessingLimitRequestsForm);
